export default __webpack_public_path__ + "static/media/30-TurquoiseWaters.ccb742ea.jpeg";